(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getContentHeight(answer) {
      const contentElement = answer.querySelector('.c-product-faq__answer-content');
      if (!contentElement) return 0;

      const clone = contentElement.cloneNode(true);
      clone.style.position = 'absolute';
      clone.style.visibility = 'hidden';
      clone.style.height = 'auto';
      clone.style.maxHeight = 'none';
      clone.style.overflow = 'visible';
      clone.style.width = contentElement.offsetWidth + 'px';
      document.body.appendChild(clone);

      const contentHeight = clone.offsetHeight;
      document.body.removeChild(clone);

      return contentHeight;
    }

    function closeAllFaqs(list) {
      list.querySelectorAll('.c-product-faq__item').forEach((item) => {
        const button = item.querySelector('.c-product-faq__question');
        const answer = item.querySelector('.c-product-faq__answer');
        if (!button || !answer) return;

        answer.style.height = '0px';
        answer.inert = true;
        button.setAttribute('aria-expanded', 'false');
      });
    }

    function openFaq(item) {
      const button = item.querySelector('.c-product-faq__question');
      const answer = item.querySelector('.c-product-faq__answer');
      if (!button || !answer) return;

      answer.inert = false;
      answer.style.height = getContentHeight(answer) + 'px';
      button.setAttribute('aria-expanded', 'true');
    }

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.c-product-faq__question');
      if (!button) return;

      const list = button.closest('.c-product-faq__list');
      const item = button.closest('.c-product-faq__item');
      if (!list || !item) return;

      const isOpen = button.getAttribute('aria-expanded') === 'true';

      closeAllFaqs(list);

      if (!isOpen) openFaq(item);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-information"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.c-variant__item input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => {
        const price = input
          .closest('.c-variant__item')
          .querySelector('.variant-option__button-label__text')?.textContent;
        const priceEl = document.querySelector('.c-product__media-price');
        if (price && priceEl) priceEl.textContent = price;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
